<template>
  <div id="sideBarDiv">

    <Menu theme="light" @on-select="linkTo" :active-name="activeName" :open-names='openNames'  ref="resetMenu">
        <template v-for="item in menuList">
          <template v-if="item.nodes">
            <Submenu :key="item.index" :name="item.url">
              <template slot="title">
                  <!-- <i class="iconfont" v-html="item.icon"></i> -->
                   <Icon type="ios-paper" />
                   {{item.name}}
              </template>
              <template v-for="subItem in item.nodes">
                <template v-if="subItem.nodes.length>0">
                <!-- <template v-if="subItem.nodes"> -->
                  <Submenu :key="subItem.index" :name="subItem.url">
                    <template slot="title">
                        <!-- <i class="iconfont" v-html="item.icon"></i> -->
                        <Icon type="md-cog" />
                         {{subItem.name}}
                    </template>
                    <MenuItem :key="subsItem.index" v-for="subsItem in subItem.nodes" :name="subsItem.url">
                        <!-- <i class="iconfont" v-html="item.icon"></i> -->
                        <Icon type="ios-closed-captioning" />
                         {{subsItem.name}}
                    </MenuItem>
                  </Submenu>
                </template>
                <template v-else>
                  <MenuItem :key="subItem.index" :name="subItem.url">
                      <!-- <i class="iconfont" v-html="item.icon"></i> -->
                      <Icon type="md-cog" />
                       {{subItem.name}}
                  </MenuItem>
                </template>
              </template>
            </Submenu>
          </template>
          <template v-else>
            <MenuItem :key="item.index" :name="item.url">
              <!-- <Icon :key="item.index" type="ios-list-outline"></Icon> -->
               <!-- <i class="iconfont" v-html="item.icon"></i> -->
               <Icon type="md-easel" />
              {{item.name}}
            </MenuItem>
          </template>
        </template>
    </Menu>

  </div>
</template>
<script>
    export default {
      props: ['routerForm'],
      name:'H3cSidebar',
      created () {
        this.getMenuByServer()
      },
      data(){
        return{
          menuList: [
            { 
              name:'',
              url:'',
              nodes:[]
            }
          ]
        }
      },
      methods:{
        linkTo (name) {
          this.$router.push('/' + name)
          this.$emit('on-change', name)
        },
        getMenuByServer(){
          let url = `${this.$store.state.islhurl}getUserMenu`
          let parms = {
            islhToken : sessionStorage.getItem('islhtoken'),
          }
          console.log(parms);
          this._post(url,parms).then(
            res =>{
              this.menuList = res.menus;
              const childMenuList = [];
              res.menus && res.menus.forEach(item => {
                item.nodes && item.nodes.forEach(childMenu => {
                  childMenuList.push(childMenu.url)
                  // 收集三级菜单URL
                  childMenu.nodes && childMenu.nodes.forEach(subMenu => {
                    childMenuList.push(subMenu.url)
                  });
                });
              });
              console.log('childMenuList', childMenuList)
              this.$store.commit('setMenuList', childMenuList)

              // 登录后重定向处理：菜单权限加载完成后，检查是否有待跳转的路径
              const redirectUrl = sessionStorage.getItem('redirectUrl')
              if (redirectUrl) {
                sessionStorage.removeItem('redirectUrl')
                const pathSegments = redirectUrl.split('/').filter(Boolean)
                const hasPermission = pathSegments.some(segment => childMenuList.indexOf(segment) !== -1)
                if (hasPermission) {
                  this.$router.push('/' + redirectUrl)
                  this.$store.commit('tagChange', redirectUrl)
                }
                // 无权限则不跳转，停留在首页
              }
              // this.menuList.push({
              //   description: "Project Manager Management",
              //   name: "项目经理映射管理",
              //   nodeId: 10,
              //   nodes: [{
              //         description:"Project Manager Management",
              //         name: "项目经理映射管理",
              //         nodeId: 11,
              //         nodes: [],
              //         pid: 3,
              //         url: "manager",
              //         }],
              //   pid: 0,
              //   url: "Project Manager Management",
              // })
            }
          )
        },
        // 从菜单树中查找目标 url 对应的所有祖先子菜单 url（用于展开父级）
        findOpenNames (menus, target, parents) {
          parents = parents || []
          if (!menus || !menus.length) return null
          for (var i = 0; i < menus.length; i++) {
            var m = menus[i]
            if (m.url === target) {
              return parents
            }
            if (m.nodes && m.nodes.length > 0) {
              var res = this.findOpenNames(m.nodes, target, parents.concat(m.url))
              if (res) return res
            }
          }
          return null
        },
        // 调用 iView Menu 的官方方法重新展开/高亮，避免直接操作 DOM 被 v-show 还原
        refreshMenu () {
          this.$nextTick(() => {
            if (this.$refs.resetMenu) {
              this.$refs.resetMenu.updateOpened()
              this.$refs.resetMenu.updateActiveName()
            }
          })
        }
      },
      computed: {
        onRoutes () {
          let a = this.$route.path.replace('/', '')
          return this.$route.path.replace('/', '')
        },
        activeName () {      // 获取打开的标签
          return this.$store.state.tabOpen
        },
        openNames () {
            if(this.$i18n.locale ==='en'){
              for (var val of this.menuList) {                    
                if(val.nodes !=='undefine' && val.nodes !== ''){
                  for (var val2 of val.nodes) {                    
                    val2.name = val2.description
                    if(val2.nodes !=='undefine' && val2.nodes !== ''){
                       for (var val3 of val2.nodes) {                    
                        val3.name = val3.description
                      }
                    }
                  }
                }
                val.name = val.description
              }
            }
            if(this.$i18n.locale ==='zh'){
              // 菜单数据已在 created 中通过 getMenuByServer 获取，
              // 此处不再调用以免 openNames 依赖 menuList 造成无限循环
            }
            // 根据当前激活的菜单项，从菜单树中回溯其所有祖先（子菜单）的 url，
            // 保证无论几层级，父级菜单都能保持展开
            var openName = this.findOpenNames(this.menuList, this.$store.state.tabOpen) || []
            return openName
        },
      },
      watch: {
        // 菜单数据加载完成后，依赖正确的 openNames 重新展开菜单
        menuList () {
          this.refreshMenu()
        }
      },
    }
</script>

<style lang="less" type='text/less'>

#sideBarDiv {
    position: absolute;
    top: 70px;
    bottom: 0;
    left: 0;
    background-color: #f2f2f2;
    overflow-x: hidden;
    overflow-y: auto;
  
  .layout-header-bar-1{
    background-color: #f2f2f2;
  }
  .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #2d8cf0; 
    background-color: #90caf980;
    z-index: 2;
  }
  
  .ivu-menu-submenu-title span>i, .ivu-menu-submenu-title>i {
      margin-right: 8px;
  }
  .iconfont {
      font-family: "iconfont" !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }
  * {
      box-sizing: border-box;
      -webkit-tap-highlight-color: transparent;
  }
  user agent stylesheet
  i, cite, em, var, address, dfn {
      font-style: italic;
  }
  .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
      padding: 14px 10px;
      position: relative;
      cursor: pointer;
      z-index: 1;
      transition: all .2s ease-in-out;
  }
  .ivu-menu {
      display: block;
      margin: 0;
      padding: 0;
      outline: 0;
      list-style: none;
      font-size: 14px;
      position: relative;
      z-index: 900;
      color: #333333;
  }
  @-moz-document url-prefix() { 
    #sideBarDiv{
      width: 260px;
    }
  }
  /* 二级菜单项：MenuItem 和 Submenu title 统一缩进对齐 */
  .ivu-menu .ivu-menu-submenu > .ivu-menu .ivu-menu-item,
  .ivu-menu .ivu-menu-submenu > .ivu-menu .ivu-menu-submenu-title {
    padding-left: 20px !important;
  }
  /* 三级菜单项：比二级多缩进一层 */
  .ivu-menu .ivu-menu-submenu .ivu-menu-submenu > .ivu-menu .ivu-menu-item {
    padding-left: 40px !important;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/public/sidebar.vue